import { apiHelper, sharedHelper } from '@/utils'
import { API } from '@/constants'

export const checkPointServices = {
    getAllCheckPoints,
    getCheckPoint,
    updateCheckPoint,
    createCheckPoint,
    updateCheckPointStatus,
    cloneCheckPoint
};

const MODULE = {
    CHECK_POINT: 'company-check-points',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllCheckPoints(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.CHECK_POINT}`, requestOptions)
}

export function getCheckPoint(id) {
    return apiHelper(API_URL).get(`/${MODULE.CHECK_POINT}/${id}`)
}

export function updateCheckPoint(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'check_point_uuid', data.checkPointID.value);
    sharedHelper.appendIfNotNull(formData, 'service_uuid', data.serviceID.value);
    sharedHelper.appendIfNotNull(formData, 'version', data.version);
    sharedHelper.appendIfNotNull(formData, 'answer_type_id', data.answerTypeID.code);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);
    formData.append('_method', 'PUT');

    if (data.image instanceof File) {
        formData.append('image', data.image);
    }

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    data.answers.forEach((answer, answerIndex) => {
        sharedHelper.appendIfNotNull(formData, `answers[${answerIndex}][uuid]`, answer.uuid);
        sharedHelper.appendIfNotNull(formData, `answers[${answerIndex}][label_uuid]`, answer.labelID.value);
        // sharedHelper.appendIfNotNull(formData, `answers[${answerIndex}][is_active]`, answer.isActive);
        sharedHelper.appendIfNotNull(formData, `answers[${answerIndex}][description]`, answer.description);
        sharedHelper.appendIfNotNull(formData, `answers[${answerIndex}][version]`, answer.version);

        if (answer.isActive == 0 || answer.isActive == false) {
            formData.append(`answers[${answerIndex}][is_active]`, 0);
        }
        else {
            formData.append(`answers[${answerIndex}][is_active]`, 1);
        }

        answer.names.forEach((name, answerNameIndex) => {
            formData.append(`answers[${answerIndex}][name][${answerNameIndex}][language_code]`, name.language.code);
            formData.append(`answers[${answerIndex}][name][${answerNameIndex}][value]`, name.name);
        });
    });

    data.newAnswers.forEach((answer, answerIndex) => {
        sharedHelper.appendIfNotNull(formData, `new_answer[${answerIndex}][label_uuid]`, answer.labelID.value);
        sharedHelper.appendIfNotNull(formData, `new_answer[${answerIndex}][description]`, answer.description);

        answer.names.forEach((name, answerNameIndex) => {
            formData.append(`new_answer[${answerIndex}][name][${answerNameIndex}][language_code]`, name.language.code);
            formData.append(`new_answer[${answerIndex}][name][${answerNameIndex}][value]`, name.name);
        });
    });



    return apiHelper(API_URL).post(`/${MODULE.CHECK_POINT}/${data.id}`, formData)
}

export function createCheckPoint(data) {
    const formData = new FormData();

    data.forEach((checkPoint, index) => {

        if (checkPoint.image instanceof File) {
            formData.append(`check_points[${index}][image]`, checkPoint.image);
        }

        formData.append(`check_points[${index}][service_uuid]`, checkPoint.serviceID.value);
        formData.append(`check_points[${index}][answer_type_id]`, checkPoint.answerTypeID.code);
        formData.append(`check_points[${index}][description]`, checkPoint.description);

        checkPoint.names.forEach((name, nameIndex) => {
            formData.append(`check_points[${index}][name][${nameIndex}][language_code]`, name.language.code);
            formData.append(`check_points[${index}][name][${nameIndex}][value]`, name.name);
        });

        if (checkPoint.checkPointID != null && checkPoint.checkPointID != undefined) {
            formData.append(`check_points[${index}][check_point_uuid]`, checkPoint.checkPointID.value);
        }

        if (checkPoint.answerTypeID != null && (checkPoint.answerTypeID.code == 0 || checkPoint.answerTypeID.code == 3)) {
            checkPoint.answers.forEach((answer, answerIndex) => {
                answer.names.forEach((name, answerNameIndex) => {
                    formData.append(`check_points[${index}][answers][${answerIndex}][text][${answerNameIndex}][language_code]`, name.language.code);
                    formData.append(`check_points[${index}][answers][${answerIndex}][text][${answerNameIndex}][value]`, name.name);
                });

                formData.append(`check_points[${index}][answers][${answerIndex}][label_uuid]`, answer.labelID.value);
                formData.append(`check_points[${index}][answers][${answerIndex}][description]`, answer.description);
            });
        }

    });

    return apiHelper(API_URL).post(`/${MODULE.CHECK_POINT}`, formData)
}

export function updateCheckPointStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.CHECK_POINT}/${data.id}`, requestOptions)

}

export function cloneCheckPoint(data) {
    const requestOptions = {
        clone_from_service_uuid: data.cloneFromServiceID,
        clone_to_service_uuid: data.cloneToServiceID
    }

    return apiHelper(API_URL).post(`/${MODULE.CHECK_POINT}/clone`, requestOptions)
}